import { Screen } from '@/components/layout'
import { Button, InlineError } from '@/components/primitives'
import { t } from '@/lib/copy'
import { useNavigate, useRoute } from '@/lib/router'

/**
 * A connection failed or was cancelled. Cancelling is a choice, not a fault,
 * so it gets its own line — and either way the statement-upload path is still
 * offered, because linking is an addition to upload and not a replacement.
 *
 * The provider's error code arrives as `?code=` and is never rendered: it is
 * for logs, like `message` on error.schema.json.
 */
export function LinkErrorScreen() {
  const navigate = useNavigate()
  const route = useRoute()
  const cancelled = route.query.get('reason') === 'cancelled'

  return (
    <Screen id="linkError" state="ready" back={{ screen: 'linkAccount' }}>
      <div className="stack">
        <InlineError>{cancelled ? t('linkError.cancelled') : t('linkError.generic')}</InlineError>
        <div className="row">
          <Button variant="primary" onClick={() => navigate('linkAccount')}>
            {t('linkError.cta.retry')}
          </Button>
          <Button variant="secondary" onClick={() => navigate('upload')}>
            {t('linkError.cta.upload')}
          </Button>
        </div>
      </div>
    </Screen>
  )
}
